// src/components/admin/ServicesEditor.js
import React, { useState, useEffect } from 'react';
import './EditorStyles.css';

const ServicesEditor = () => {
  const [services, setServices] = useState([
    {
      id: 1,
      title: "Service 1",
      description: "Description for service 1",
      icon: "fa-truck",
    },
    {
      id: 2,
      title: "Service 2",
      description: "Description for service 2",
      icon: "fa-chart-line",
    },
    {
      id: 3,
      title: "Service 3",
      description: "Description for service 3",
      icon: "fa-box",
    },
  ]);
  
  const [currentService, setCurrentService] = useState(null);
  const [sectionTitle, setSectionTitle] = useState("Our Services");
  
  const handleAddService = () => {
    const newService = {
      id: Date.now(),
      title: "New Service",
      description: "Enter service description",
      icon: "fa-star",
    };
    
    setServices([...services, newService]);
    setCurrentService(newService);
  };
  
  const handleEditService = (service) => {
    setCurrentService({...service});
  };
  
  const handleDeleteService = (serviceId) => {
    if (window.confirm("Are you sure you want to delete this service?")) {
      setServices(services.filter(service => service.id !== serviceId));
      if (currentService && currentService.id === serviceId) {
        setCurrentService(null);
      }
    }
  };
  
  const handleServiceChange = (e) => {
    const { name, value } = e.target;
    setCurrentService(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSaveService = () => {
    setServices(services.map(service => 
      service.id === currentService.id ? currentService : service
    ));
    
    alert("Service saved successfully!");
  };
  
  const handleSaveAll = () => {
    // Here you would save all services to your backend
    console.log("Saving all services:", { sectionTitle, services });
    alert("All changes saved successfully!");
  };
  
  return (
    <div className="section-editor">
      <h2>Edit Services Section</h2>
      
      <div className="form-group">
        <label>Section Title</label>
        <input 
          type="text" 
          value={sectionTitle}
          onChange={(e) => setSectionTitle(e.target.value)}
        />
      </div>
      
      <div className="services-list">
        <h3>Services List</h3>
        <div className="services-grid">
          {services.map(service => (
            <div key={service.id} className="service-item">
              <h4>{service.title}</h4>
              <div className="service-actions">
                <button 
                  className="edit-button"
                  onClick={() => handleEditService(service)}
                >
                  Edit
                </button>
                <button 
                  className="delete-button"
                  onClick={() => handleDeleteService(service.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
          <button className="add-service-button" onClick={handleAddService}>
            + Add New Service
          </button>
        </div>
      </div>
      
      {currentService && (
        <div className="service-editor">
          <h3>Edit Service</h3>
          
          <div className="form-group">
            <label>Service Title</label>
            <input 
              type="text"
              name="title"
              value={currentService.title}
              onChange={handleServiceChange}
            />
          </div>
          
          <div className="form-group">
            <label>Service Description</label>
            <textarea
              name="description"
              value={currentService.description}
              onChange={handleServiceChange}
              rows="4"
            />
          </div>
          
          <div className="form-group">
            <label>Icon Class (FontAwesome)</label>
            <input 
              type="text"
              name="icon"
              value={currentService.icon}
              onChange={handleServiceChange}
            />
            <div className="icon-preview">
              <i className={`fas ${currentService.icon}`}></i>
              <span>Icon Preview</span>
            </div>
          </div>
          
          <button 
            className="save-button"
            onClick={handleSaveService}
          >
            Save Service
          </button>
        </div>
      )}
      
      <div className="form-actions">
        <button 
          className="save-all-button"
          onClick={handleSaveAll}
        >
          Save All Changes
        </button>
      </div>
    </div>
  );
};

export default ServicesEditor;